import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import { SignupForm } from './widgets';
import { Footer } from '@shared/widgets';
import LogoLightIcon from '@assets/icons/logo/logo-small.svg';
import LogoDarkIcon from '@assets/icons/logo/logo-small-dark.svg';

export const SignUpPage = () => {
  useEffect(() => {
    document.title = 'Sign Up';
  }, []);

  return (
    <>
      <div className='flex flex-col min-h-screen relative'>
        <div className='flex flex-col py-24 px-0 flex-auto relative overflow-hidden items-center flex-nowrap justify-center'>
          <div className='absolute left-0 top-[3%] w-full min-h-20 flex'>
            <div className='container container_wide'>
              <NavLink className='inline-block align-top' to={RoutePaths.dashboard.onNavigate()}>
                <LogoLightIcon className='dark:hidden' />
                <LogoDarkIcon className='hidden dark:inline-block' />
              </NavLink>
            </div>
          </div>
          <div className='w-full max-w-[1290px] px-8 mx-auto'>
            <div className='w-20'>
              <div className='mb-12'>
                <div className='big-title'>Registration</div>
              </div>
              <SignupForm className='w-64' />
            </div>
          </div>
          <div className='auth-page__img auth-page__img::before' />
        </div>
      </div>
      <Footer />
    </>
  );
};
